
<div class="mt-2 mb-2" v-b-tooltip.hover :title="item.id ? '' : 'Please save this task, before adding labels'">
  <button :disabled="!item.id" class="btn btn-block btn-info" id="addLabel">
    <i class="icon-left far fa-tags"></i>
    Label
  </button>

  <b-popover target="addLabel" ref="addLabel" triggers="click blur">
    <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Add Label</div>
    <hr class="mt-2 mb-2" />
    <input type="text" v-model="filter" class="form-control mb-2 mt-1" placeholder="Filter..." />

    <div class="bi-label-container">
      <div v-for="label in filteredLabels" :key="label.id">
        <div
          class="bi-label mb-2 cursor-pointer"
          :style="{
            'background-color': label.color,
          }"
          @click="addLabel(label.id)"
        >
          <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
          {{ label.title }}
        </div>
      </div>

      <div v-if="!filteredLabels.length">
        <div class="bi-label no-available-labels mb-2">No labels available</div>
      </div>
    </div>
  </b-popover>
</div>
